<div class="mb-3">
    @if (isReadOnly) {
        <div>
            @if (label != null) {
                <label>{{ label }}</label>
            }
            @if (showRequired) {
                <span class="required-indicator">*</span>
            }
            <input readonly="true" type="text" [id]="id" class="form-control" [value]="readOnlyData" />
        </div>
    }
    @if (!isReadOnly) {
        <div>
            @if (label != null) {
                <label>{{ label }}</label>
            }
            @if (showRequired) {
                <span class="required-indicator">*</span>
            }
            <div class="ui-fluid">
                <p-select
                    placeholder="Not Selected"
                    [options]="options"
                    [showClear]="removable"
                    autoWidth="false"
                    [filter]="searchFilter"
                    [formControl]="control"
                    [resetFilterOnHide]="searchFilter"
                    [fluid]="true"
                    [appendTo]="appendTo"
                    [id]="id"
                ></p-select>
            </div>
            @if (control.invalid) {
                <span class="help-block">
                    <span class="required-indicator">
                        {{ getErrorMessage() }}
                    </span>
                </span>
            }
        </div>
    }
</div>
